import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { IQuestionnaire, QuestionnaireType } from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { IComboObject } from "../objects";
import { IQuestionnairePropertyEditable } from "../properties";
import { ComboObjectEditor } from "./ComboObjectEditor";

export class QuestionnaireComboObjectEditor extends ComboObjectEditor implements IQuestionnairePropertyEditable {
  constructor(source: IComboObject | QuestionnaireComboObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._questionnaire = this.createPropertyEditor(s => s.questionnaire, (s, v) => s.questionnaire = v);
  }

  protected _questionnaire: IPropertyEditable<IQuestionnaire>;

  questionnaire(): IPropertyEditable<IQuestionnaire> {
    return this._questionnaire;
  }

  selectableQuestionnaireTypes(): (QuestionnaireType | undefined)[] {
    return ["choice"];
  }

  clone(): IFormatObjectEditable {
    return new QuestionnaireComboObjectEditor(this);
  }
}
